// export const SERVER_URL = "http://localhost:5005";
// export const SERVER_URL = "https://coral-app-merc3.ondigitalocean.app";
export const SERVER_URL = "https://igts-back.onrender.com";
